import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
// import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import SpecificityService from "../services/SpecificityService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { BlockPicker } from "react-color";

const DataTableSpecificity = () => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  const [specificities, setSpecificities] = useState([]);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const animatedComponents = makeAnimated();
  const [availableSpecificity, setAvailableSpecificity] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [specificitySelectPlaceHolder, setSpecificitySelectPlaceHolder] =
    useState("Choisir une spécificité produits");
  const [specifityChoosen, setSpecifityChoosen] = useState([]);
  const [typeSpecificity, setTypeSpecificity] = useState("");
  const [libelleColor, setLibelleColor] = useState("");
  const [descriptionSpecificity, setDescriptionSpecificity] = useState("");
  const [background, setBackground] = useState("#FF5733");
  const [specificityTableData, setSpecificityTableData] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [specifityById, setSpecifityById] = useState([]);

  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  useEffect(() => {
    SpecificityService.getProductSpecificityByCategory(
      getCurrentUserId(),
      sessionStorage.getItem("idCategory")
    ).then((responseSpecificite) => {
      setAvailableSpecificity(responseSpecificite.data);
    });
  }, []);
  useEffect(() => {
    setSpecificities([]);

    availableSpecificity &&
      availableSpecificity.map((element, i) => {
        setSpecificities((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: element.type,
          },
        ]);
      });
  }, [availableSpecificity]);
  // const { SearchBar } = Search;
  // const MyExportCSV = (props) => {
  //   const handleClick = () => {
  //     props.onExport();
  //   };
  //   return (
  //     <div>
  //       <button className="btn btn-dark" onClick={handleClick}>
  //         <i class="fas fa-download"></i> Télécharger CSV
  //       </button>
  //     </div>
  //   );
  // };

  const columns = [
    {
      dataField: "name",
      text: "Libellé",
    },
    {
      dataField: "value",
      text: "Valeur",
    },
    {
      dataField: "description",
      text: "Description",
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onChangeValueHandler = (event) => {
    setBackground(event.target.value);
  };
  const handleChangeComplete = (color, event) => {
    setBackground(color.hex);
  };
  const changeLibelleSpecificityHandler = (event) => {
    setLibelleColor(event.target.value);
  };
  const changeDescriptionSpecificityHandler = (event) => {
    setDescriptionSpecificity(event.target.value);
  };

  // function handleTableChange({ specificities }) {
  //   return specificities;
  // }
  // const pageButtonRenderer = ({
  //   page,
  //   active,
  //   disable,
  //   title,
  //   onPageChange,
  // }) => {
  //   const handleClick = (e) => {
  //     e.preventDefault();
  //     onPageChange(page);
  //   };
  //   const activeStyle = {};
  //   if (active) {
  //     activeStyle.backgroundColor = "black";
  //     activeStyle.color = "white";
  //   } else {
  //     activeStyle.backgroundColor = "white";
  //     activeStyle.color = "black";
  //   }
  //   if (typeof page === "string") {
  //     activeStyle.backgroundColor = "white";
  //     activeStyle.color = "black";
  //   }
  //   return (
  //     <li className="page-item">
  //       <button
  //         className="btn btn-dark"
  //         onClick={handleClick}
  //         style={activeStyle}
  //       >
  //         {page}
  //       </button>
  //     </li>
  //   );
  // };

  const onAddSpecificityToList = (event) => {
    if (specifityChoosen === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un produit ");
    } else {
      setSpecifityById((previoustate) => [
        ...previoustate,
        {
          name: libelleColor,
          idProductSpecificity: specifityChoosen,
          value: background,
          description: descriptionSpecificity,
        },
      ]);
      setSpecificityTableData((previoustate) => [
        ...previoustate,
        {
          name: libelleColor,
          idProductSpecificity: specifityChoosen,
          value: background,
          description: descriptionSpecificity,
        },
      ]);
      sessionStorage.setItem("ListSpecificities", specificityTableData);
      console.log("session List", sessionStorage.getItem("ListSpecificities"));
    }
  };
  const onChangeSelected = (selectedOption) => {
    setSelectedOption();
    setSpecifityChoosen(selectedOption.value);
    setSpecificitySelectPlaceHolder(selectedOption.label);
    setTypeSpecificity(selectedOption.customElements);
  };

  const blocSpecificity = () => {
    if (typeSpecificity === 1) {
      return (
        <div className="row">
          <div className="col-md-4">
            <label>Libellé de la couleur:</label>
            <input
              type="libelle"
              className="form-control"
              placeholder="Ajouter libellé"
              value={libelleColor}
              onChange={changeLibelleSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Description:</label>
            <input
              type="description"
              className="form-control"
              placeholder="Ajouter description"
              value={descriptionSpecificity}
              onChange={changeDescriptionSpecificityHandler}
            />
          </div>

          <div className="col-md-4">
            <label>Choisir la couleur : </label>
            <BlockPicker
              color={background}
              onChangeComplete={handleChangeComplete}
            />
          </div>
          <div className="form-group" class="col-sm-4 ">
            <button
              style={{ marginTop: 20, marginBottom: 20 }}
              class="btn btn-dark  float-right"
              onClick={onAddSpecificityToList}
            >
              <i class="fas fa-plus"></i>
              Liste des spécificitées{" "}
            </button>
          </div>
        </div>
      );
    } else if (typeSpecificity === 0) {
      return (
        <div className="row">
          <div className="col-md-4">
            <label>Libellé de la couleur:</label>
            <input
              type="libelle"
              className="form-control"
              placeholder="Ajouter libellé"
              value={libelleColor}
              onChange={changeLibelleSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Description:</label>
            <input
              type="description"
              className="form-control"
              placeholder="Ajouter Description"
              value={descriptionSpecificity}
              onChange={changeDescriptionSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Valeur:</label>
            <input
              type="valeur"
              className="form-control"
              placeholder="Ajouter libellé"
              value={background}
              onChange={onChangeValueHandler}
            />
          </div>

          <div className="form-group" class="col-sm-4 ">
            <button
              style={{ marginTop: 20, marginBottom: 20 }}
              class="btn btn-dark  float-right"
              onClick={onAddSpecificityToList}
            >
              <i class="fas fa-plus"></i>
              Liste des spécificitées{" "}
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      <div class="row">
        <div className="col-sm-6">
          <div className="form-group">
            <label>Choisir une spécificité</label>
            <Select
              styles={styles}
              closeMenuOnSelect={true}
              components={animatedComponents}
              defaultValue={selectedOption}
              onChange={onChangeSelected}
              options={specificities}
              placeholder={specificitySelectPlaceHolder}
              menuPlacement={"top"}
            />
          </div>
        </div>
      </div>
      {blocSpecificity()}
      {console.log("listSpecificités", specificityTableData)}
      {specificityTableData && (
        <ToolkitProvider
          keyField="id"
          data={specificityTableData}
          columns={columns}
        >
          {(props) => (
            <div>
              <div className="row">
                <BootstrapTable {...props.baseProps} striped hover condensed />
              </div>
            </div>
          )}
        </ToolkitProvider>
      )}

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableSpecificity;
